// src/config/payment.config.ts
export interface PaymentConfig {
  basePlatformFee: number; // Minimum required platform fee
  vatRate: number;
  currency: string;
  petalRate: number;
  minBouquetAmount: number;
  maxBouquetAmount: number;
  paymentMethods: ("card" | "bank" | "ussd" | "qr")[];
  // New fields for optional contributions
  allowExtraContribution: boolean;
  extraContributionStep: number; // Increment steps (e.g., 100 KES)
  maxExtraContribution: number; // Maximum extra amount
}

export const PAYMENT_CONFIG: PaymentConfig = {
  basePlatformFee: 258,
  vatRate: 0.16,
  currency: "KES",
  petalRate: 1000,
  minBouquetAmount: 1000,
  maxBouquetAmount: 1000000,
  paymentMethods: ["card", "bank", "ussd", "qr"],
  // New fields
  allowExtraContribution: true,
  extraContributionStep: 100,
  maxExtraContribution: 10000, // Max extra amount users can add
};

// Add back PAYMENT_MESSAGES
export const PAYMENT_MESSAGES = {
  SUCCESS: "Payment successful! 🎉",
  PROCESSING: "Processing your payment...",
  CANCELLED: "Payment cancelled",
  ERROR: "Payment failed. Please try again.",
  INIT_ERROR: "Failed to initialize payment",
  VERIFY_ERROR: "Failed to verify payment",
  AUTH_REQUIRED: "Please sign in to continue",
} as const;

// Add back PAYMENT_ROUTES
export const PAYMENT_ROUTES = {
  SUCCESS_DELAY: 2000,
  SHARE_PAGE: (cardId: string) => `/share/${cardId}`,
} as const;
